import { render, staticRenderFns } from "./BetterCareIcon.vue?vue&type=template&id=75f68ceb&"
import script from "./BetterCareIcon.vue?vue&type=script&lang=js&"
export * from "./BetterCareIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports